export default "/images/vendor/flag-icons/flags/1x1/zm.svg?c4a09669d91876442c10d3676310aa2c";